module.exports = __webpack_public_path__ + "fonts/TelefonicaWeb-Light.c21edbc3.woff";